module.exports = __webpack_public_path__ + "img/4-star-1000.e083c35b.png";